import React, { useState } from 'react';

// COMPONENTS
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import Button from "@/main/components/shared/button/button";

// UTILS/SERVICES/MODELS
import { supplierInventoryApi } from "@/main/api";
import { getTranslateByKey } from "@/main/services/utils";

// STYLES & COMPONENTS LOCAL
import * as S from './styles';
import { UpdateStatusDeletedRequest } from '@/main/models/request';

interface IModalConfirmDeletePartPartProps {
  openModalConfirm: boolean;
  supplierInventoryWarehouseGuid: string;
  setOpenModalConfirm: React.Dispatch<React.SetStateAction<boolean>>;
  callbackAfterRemovePart?: (hasLastPartInCart: boolean) => void;
}
function ModalConfirmDeletePartPart({
  supplierInventoryWarehouseGuid,
  setOpenModalConfirm,
  callbackAfterRemovePart
}: IModalConfirmDeletePartPartProps) {
  const [isLoadingRemove, setIsLoadingRemove] = useState<boolean>(false);

  async function onClickActionConfirm() {
    try {
      setIsLoadingRemove(true)
      const request: UpdateStatusDeletedRequest = {
        supplierInventoryWarehouseGuid
      }
      const { data: { result } } = await supplierInventoryApi.updateStatusDeleted(request);
      if (result) {
        if (callbackAfterRemovePart) callbackAfterRemovePart(true)
      }

    } catch (error) {
      console.error(error)
    } finally {
      setIsLoadingRemove(false)
      setOpenModalConfirm(false);
    }
  }

  return (
    <S.Container>
      <p>{getTranslateByKey("information.confirmDeletePartInventory")}</p>
      <S.FooterButtons>
        <SecondaryButton
          id="id-partsCatelog-btn-no"
          type="button"
          disabled={isLoadingRemove}
          onClick={() => { setOpenModalConfirm(false) }}
        >
          {getTranslateByKey('information.no')}
        </SecondaryButton>
        <Button
          id="id-partsCatelog-btn-yes"
          type="button"
          isLoading={isLoadingRemove}
          onClick={() => onClickActionConfirm()}
        >
          {getTranslateByKey('information.yes')}
        </Button>
      </S.FooterButtons>
    </S.Container >
  )
}
function WrapperModalConfirmDeletePart(props: IModalConfirmDeletePartPartProps) {
  return (
    <KogModalFadeComponent
      isInModal
      open={props.openModalConfirm}
      setOpen={props.setOpenModalConfirm}
    >
      {props.openModalConfirm ? (
        <ModalConfirmDeletePartPart {...props} />
      ) : <div />}

    </KogModalFadeComponent>
  )
}
export default WrapperModalConfirmDeletePart;